import { Badge } from '@/components/ui/badge'
import { Spinner } from '@/components/ui/spinner'
import { type GeicoQaRun, GeicoQaRunStatus } from '@/models/geicoQa'

const STATUS_LABELS: Record<GeicoQaRunStatus, string> = {
  [GeicoQaRunStatus.Pending]: 'Running',
  [GeicoQaRunStatus.Quoted]: 'Quoted',
  [GeicoQaRunStatus.Declined]: 'Declined',
  [GeicoQaRunStatus.Error]: 'Error',
}

function GeicoQaOutcome({ outcome }: { outcome: GeicoQaRunStatus }) {
  return <Badge variant="outline">{STATUS_LABELS[outcome]}</Badge>
}

/** Pass, fail or still running — the column someone actually scans. */
export function GeicoQaVerdict({ run }: { run: GeicoQaRun | null }) {
  if (!run) return <span className="text-muted-foreground text-sm">Never run</span>

  if (run.status === GeicoQaRunStatus.Pending) {
    return (
      <span className="text-muted-foreground flex items-center gap-2 text-sm">
        <Spinner className="size-3" />
        {run.attempt > 0 ? `Retry ${run.attempt}` : 'Running'}
      </span>
    )
  }

  return (
    <span className="flex flex-wrap items-center gap-2">
      <Badge variant={run.passed ? 'success' : 'destructive'}>{run.passed ? 'Pass' : 'Fail'}</Badge>
      <GeicoQaOutcome outcome={run.status} />
    </span>
  )
}
